<template lang="pug">
  section
    .overSlide
      h1(v-scroll-reveal={origin: 'right', distance: '100px'}) {{ content.title }}
      h3(v-show="content.subTitle", v-scroll-reveal={origin: 'right', distance: '100px', delay: 500}) {{ content.subTitle }}
      a.btn-cta(v-show="content.btnUrl", :href="content.btnUrl", v-scroll-reveal={origin: 'right', distance: '100px', delay: 1000, opacity: 0})
        font-awesome-icon(icon="donate")
        |  線上捐款
    .hero(:class="{['no-' + content.imageNo]: content.imageNo }")
</template>

<script>
export default {
  name: 'Hero',
  props: {
    content: Object
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="sass" scoped>
section
  +size($h: $heroH)
  position: relative
  &::before
    +size($h: $heroH, $w: 100%)
    +pos($p: absolute, $t: 0, $l: 0)
    content: ''
    display: inline-block
    background: linear-gradient(to top, rgba(0,0,0,0.5) 0%,rgba(0,0,0,0) 100%)
    z-index: 1
  +rwd(mbl)
    +size($h: $heroH-mbl)
    &::before
      +size($h: $heroH-mbl)

.overSlide
  +fs($ta: left, $c: #fff)
  +pos($p: absolute, $b: 50px, $l: 50px)
  z-index: 2
  +rwd(mbl)
    +fs($ta: center)
    +pos($t: 60px, $l: 20px)
  h3
    +fs($c: $c-light-grey)
    padding: 20px 20px 0
  h1
    +fs($fw: bold, $lh: 48px)
    padding: 20px 20px 0
  a.btn-cta
    +fs($fz: 24px, $fw: 600, $lh: 22px)
    background-color: $c-primary
    border-radius: 2px
    padding: 24px 40px 16px
    margin: 20px
    border: 1px solid $c-primary
    &:hover
      +fs($c: $c-primary)
      background-color: #fff

.hero
  +size($h: $heroH, $w: 100%)
  +fs($ta: center)
  +pos($p: absolute, $b: 0, $l: 0)
  background-position: 50% 50%
  z-index: 0
  background-attachment: fixed
  background-repeat: no-repeat
  +rwd(mbl)
    +size($h: $heroH-mbl)
    background-attachment: scroll
  @for $i from 1 through 6
    &.no-#{$i}
      background-image: url('/static/images/img-hero-0#{$i}.jpg')
      background-size: cover

</style>



// WEBPACK FOOTER //
// src/components/Hero.vue